export default {
  app_name: 'made',
  app_error: {
    title: 'An unexpected error has occurred.',
    msg: 'An error has been sent to the team in charge. Please close the app and start again!',
    network: 'A network communication error has occured.',
    other_device_login: 'In another device, a user joined the same phone number.',
    image_not_supported: 'Unsupported image format....',
  },
  app_exit: 'Please press \'Back\' button again to exit.',
  permissions: {
    splash:
      'This app requires the following permissions.\n' +
      'One. Access the device\'s storage to store the app\'s internal data.\n' +
      '2. Allows access to phone numbers and email addresses for user identification.',
    splash_denied: 'This app can operate normally when all necessary permissions are granted.',
    location: 'This app is trying to access location information to find members around you.',
    camera_0: 'This app wants to access the camera to take a picture to be posted on the post.',
    camera_1: 'This app wants to access the camera to take pictures to be sent to the administrator.',
    camera_2: 'This app is trying to access the camera to take a picture to be registered in the profile.',
  },
  downloaded_files_desc: 'Download progress: %s/%s',
  common: {
    order_type: "Order Type",
    order_asc: "Ascending",
    order_desc: "Descending",
    update_all: "Update all",
    remove_price: 'Remove Price',
    download: "Download",
    ok: 'OK',
    cancel: 'Cancel',
    cancel1: 'Cancel',
    delete: 'Delete',
    delete1: 'Delete',
    agree: 'Agree',
    complete: 'Complete',
    complete1: 'Complete',
    no: 'No',
    save: 'Save',
    confirm: 'Confirm',
    install: 'Install',
    won: 'Yuan',
    man_won: '%sManYuan',
    man_won1: '%sManYuan',
    bak_man_won: '%sBaekManYuan',
    euk_won: '%sk ManYuan',
    euk_man_won: '%sk %sManYuan',
    k: '%sk',
    save_success: 'Successfully saved',
    update_success: 'Successfully updated',
    charge_success: 'Successfully charged',
    temporary_save_success: 'It was successfully sheltered.',
    delete_success: 'Successfully deleted',
    empty_hint: 'No Data',
    apply: 'Apply',
    apply1: 'Apply',
    copy: 'Copy',
    modify: 'Modify',
    modify1: 'Modify',
    reset: 'Reset',
    p: '%sP',
    attach: '첨부하기',
    upload_image_error: 'Occure failed. Pleaeas upload again.',
    new_version_exist: '새로운 버전이 출시되었습니다.\n\n설치하시겠습니까?',
    deleted_hidden_site: '매물 관리자에 의해 \'숨김\' 처리된 현장입니다.',
    update_maemul_title: 'There are properties that need renewal.',
    update_maemul_desc: 'Three are items for sale within 5 days until auto-hidden.',
    update_maemul_environment: 'Please update for a comfortable use environment.',
    move: 'Move',
    select: 'Select',
  },
  image_picker: {
    title: 'Select photo',
    camera: 'Camera',
    gallery: 'Gallery',
  },
  maemul_type: [
    'Villa / Alliance / Multigeneration',
    'City live house',
    'Officetels',
    'Apartment',
    'House',
    'Neighborhood living facilities',
  ],
  maemul_type_short: [
    'Villa / Alliance / Multigeneration',
    'City live house',
    'Officetels',
    'Apartment',
    'House',
    'Neighborhood living facilities',
  ],
  parking_info: [
    'Self propelled',
    // 'Line Parking',
    'Double Parking',
    'Machine Parking',
    'No Parking',
  ],
  trans_type: [
    'Trading',
    'Charter',
    'Invest',
    'Monthly',
  ],
  trans_type_short: [
    'T',
    'C',
    'I',
    'M',
  ],
  trans_type1: [
    'Trading',
    'Charter',
    'Invest',
    'Monthly',
  ],
  trans_type_ho: [
    'Parcel Out',
    'Charter',
    'Invest',
    'Monthly',
  ],
  dongsi: 'DongSi',
  splash: {
    title: 'Maemul\nIn Made\nCome true',
    brand: 'Made'
  },
  login: {
    login: 'Login',
    phone_placeholder: 'Enter mobile phone number.',
    maemul_placeholder: 'Enter Maemul number.',
    send_auth_num: 'Send auth num',
    auth_placeholder: 'Enter verification num.',
    auth_num_request: 'Send auth num first.',
    confirm_num: 'Confirm num',
    signup: 'Sign up',
    auth_num_sent: 'The authentification number has been sent.',
    auth_num_incorrect: 'The authentification number is incorrect.Please check again.',
    time_out: 'Time out! Please try again.',
    login_success: 'To the number registered with the Made\n' +
      'Without additional authentication process\n' +
      'You can sign up right away.'
  },
  signup_info: {
    business_card_photo: 'Business Card photo',
    bs_regist: '+ BS Regist',
    photo_guide: 'Phone auth must match number on business card.',
    photo_guide2: 'Phone auth must match number on business card.',
    affiliation_placeholder: 'Please enter affiliation.',
    name_placeholder: 'Please enter name.',
    pick_card_photo: 'Please enter Business card photo',
    all_info: 'There is information that has not been entered.',
    next_step: 'Next Step',
    auth_phone: 'Please authenticate your phone number.',
    signup_under_review: 'The application for registration has been completed.\nSubscription approval is processed sequentially every day.\nI wish you a contract Made again today.',
    cert_match: 'Correct verification Number',
    cert_match_admin: '관리자에 의하여 인증된 번호입니다.',
    cert_not_match: 'Incorrect verification Number'
  },
  signup_quiz: {
    title: 'Real Estate Industry Certification Questions',
    apply_subscription: 'Application for subscription',
    dlg_title: 'Would your like to apply for registration?',
    dlg_content: 'If information entered is different or the answer is incorrect, you can apply again the next day (%s).',
    dlg_content2: '▶ 가입신청이 거절되는 경우 ◀\n1. 실물 명함을 촬영한 사진이 아닐 때\n2. 명함 속 연락처와 인증한 연락처가 다를 때\n3. 인증 질문에 대한 답안이 틀릴 때',
    select_answer: 'Please select answer for each quiz.',
  },
  menu: {
    home: 'Home',
    interest: 'Interested Sale',
    interest1: 'Interest',
    map: 'Map',
    community: 'Community',
    more: 'View more',
  },
  admin: {
    show_admin: 'Admin screen',
    hide_admin: 'Exit admin',
    sale: 'Registered Sale',
    update_sale: 'Updated Sale',
    notice: 'Notice',
    community: 'Community',
    delete: 'Delete',
    update: 'Update',
    update1: 'Update',
    modify_sale: 'Modify Sale',
    confirm_delete_sale: 'Would you like to delete this sale?',
    confirm_delete_sale_content: 'If it deleted, can not recovery.',
    msg_user_find_success: '%s is searched by phone number.',
    lock_unlock_setting: 'Lock/Unlock Admin',
    lock_unlock_apply: 'Lock/Unlock Apply',
    password: 'Password',
    password_not_matched: 'Password dose not match.',
    unlock_hint: 'Please unlock admin first.'
  },
  admin_member: {
    mobile_phone: 'Mobile Phone Number',
    maemul_number: 'Maemul Number',
    member_manage: 'Membership number management',
    site_manage: 'Site management',
    add: 'Add',
    db_view: 'Database view',
    remove: 'Remove',
    reject_subscription: 'Restrictions on subscription',
    accept_subscription: 'Unlocking the restrictions',
    write_limit_5: '5 days writing limit',
    login_limit_5: '5-day login limit',
    confirm_remove: 'Would you like to delete the member from the DB?',
    confirm_reject_member: 'Would you like to limit membership registration?',
    confirm_accept_member: 'Would you like to lift membership restrictions?',
    confirm_5_day_write_limit: 'Would you like to limit member writing to 5 days?',
    confirm_5_day_login_limit: 'Would you like to limit member logins to 5 days?',
    msg_add_phone_success: 'Phone number was added successfully.',
    msg_remove_user_success: 'User was removed successfully.',
    msg_limit_user_success: 'Successfully blocked phone .',
    msg_lift_user_success: 'Successfully unblocked phone.',
    msg_write_limit_success: 'Successfully limit member writing until %s.',
    msg_login_limit_success: 'Successfully limit member logins until %s.',
    number: 'Number',
    affiliation: 'Affiliation',
    name: 'Name',
    contacts: 'Contracts',
    export_excel: 'Export all data',
  },
  admin_subscription: {
    subscription_title: 'Approve/reject subscription',
    reject: 'Reject',
    approve: 'Approval',
    confirm_reject: 'Would you like to decline membership?',
  },
  admin_point: {
    point_placeholder: 'Enter point.',
    period_placeholder: 'Enter period.',
    point_manage_title: 'Points, period of use provided',
    point_manage_title1: 'Points usage period management',
    point: 'Point',
    offer: 'Offer',
    deduction: 'Deduction',
    usage_period: 'Usage Period',
    msg_offer_point_success: 'Successfully offered.',
    msg_deduction_point_success: 'Successfully reduced the point.',
    msg_offer_period_success: 'Successfully provided the period of use.',
    msg_deduction_period_success: 'Successfully reduced the period of use.',
    confirm_offer_point: '%s\nWould you like to provide %s points to %s?',
    confirm_deduction_point: '%s\nWould you like to reduce the point to %s?',
    confirm_offer_period: '%s\nWould you like to provide %s period to %s?',
    confirm_deduction_period: '%s\nWould you like to shorten the %s period of use of work to %s?',
  },
  admin_point_setting: {
    point_setting_title: 'Point cost and voucher modification',
    point_setting_title1: 'Point cost and voucher management',
    made_community_writing: 'Made+ Community Writing',
    send_made_notification: 'Send Made + Notification',
    community_writing_push: 'Community writing with push function',
    send_push_notification: 'Send push function notification',
    one_month_ticket: 'One month ticket',
    current_point: 'Current Point',
    point_to_apply: 'Point to apply',
    convert_ticket: 'Convert ticket',
    free: 'Free',
    pay: 'Pay',
    show_ticket: 'Show ticket',
    show: 'Show',
    hide: 'Hiding',
    msg_update_success: 'Updated successfully.',
    confirm_change_point: 'Change the point from %s to %s.',
    confirm_change_ticket: 'Change the ticket from %s to %s.',
    confirm_change_ticket_visible: 'The ticket is %s processed.',
    confirm_change_monthly_point: 'The point of the monthly ticket change from %s to %s.',
  },
  admin_write: {
    write_manage_title: 'Write management',
  },
  admin_view_member: {
    view_member_title: 'View member information',
    business_card_photo: 'Business card photo',
    belong: 'Belong',
    name: 'Name',
    sign_up_date: 'Sign up date',
    last_access_date: 'Last access date',
    register_sale_count: 'Register sale count',
    community_post_count: 'Community post count',
    noti_regist_count: 'Noti Regist Count',
    warned_count: 'Warned count',
    remaining_point: 'Remaining points',
    point_charged: 'Point charged',
  },
  admin_ads: {
    ads_manage_title: 'Main advertisement setting',
    main_content_detail: 'What the operator wants to write',
    main_content_hint: 'Preview what the operator want to write',
    main_image_size_hint: '\nImage size: ',
    text: 'Text',
    image: 'Image',
    apply: 'Apply',
    reset: 'Reset',
    connect_detail: 'Connection details',
    link: 'Link',
    advertising: 'Advertising',
    sequence: 'Sequence',
    random: 'Random',
    ads_number: 'Advertising number',
    ads_image_hint: 'Preview ad image',
    attach: 'Attach',
    delete: 'Delete',
    duration_sec: 'Duration (sec)',
    ad_period: 'AdPeriod(Days)',
    select_ads_hint: 'Please select ads first.',
    ad_duration_input_hint: 'Please input duration seconds.',
    ad_period_input_hint: 'Please input advertisement period day.',
    connect_content_input_hint: 'Please input right connect data.'
  },
  admin_super: {
    admin_manage_title: 'Add administrator, control authority',
    save_authority: 'Administrator,\nprivilege control',
    msg_search_user_by_phone: 'Please search user by phone number first.',
  },
  admin_sale_req: {
    sale_req_title: 'Checking members who are registering for sale',
    search: 'Search',
    drop_off: 'Drop off',
    temporary_save: 'Temporary save',
    today: 'Today',
    yesterday: 'Yesterday',
    day_before_yesterday: 'Day before yesterday',
  },
  admin_sale_log: {
    sale_log_title: 'Member login/sales completed',
    sale_completed_title: 'Reported site',
    sale_completed_title_old: 'Reported site',
    member_login_title: 'Member login',
    log_in_with_other_id: 'Log in with membership number',
    move: 'Move',
    login: 'Login',
    // search_hint: 'View the sales report for sale completion',
    search_hint: 'Search sites for reported by member',
    report_member_number: 'Reported member number',
    reported_site_name: 'Reported site name',
    reported_date: 'Reported date',
  },
  home: {
    popup: 'Popup',
    new_open_site: 'New open site in the area of interest',
    monthly_site: 'Monthly list',
    monthly_site1: 'Monthly list',
    monthly_site_desc: 'Only sites within the area of interest setting are displayed.',
    regional_setting: 'Regional setting',
    open_date: 'Open Date',
    location_noti: 'Location Notification',
    today_reminder: 'Today\'s reminder list',
    usage_date_limited: "Usage date is passed",
  },
  region_popup: {
    title: 'Set area of interest',
    desc: '*전체 설정/해제는 왼쪽 지역명을 한번 더 눌러주십시오.'
  },
  interest: {
    recently_view: 'Recently viewed Sale',
    favorite_sale: 'Favorite Sale',
    reg_date: 'RegiDate',
    open_date: 'OpenDate',
    supply_meal: 'Meal Supply',
    trading: 'Trading',
    trading1: 'Trading',
    charter: 'Charter',
    relief: 'Relief',
    smb: 'SMB',
    invest: 'Invest',
    monthly: 'Monthly',
    desc_monthly: 'With Monthly',
    call_phone: 'Call Phone',
    completion_report: 'Completion\nreport',
    navi_connect: 'Navi Connect',
    copy_address: 'Copy Address',
    site_notify: 'Site Notify',
    no_contact: 'No Contact',
    report_title: 'Would you like to report the completion of the sale?',
    report_confirm: 'If you report correctly, you will receive 1000 points.',
    report_confirm1: 'However, if inaccurate reports are accumulated 3 times\nNo more reporting is possible.',
    report_confirm_click: 'Points are provided after confirmation of the transaction completion.',
    report_confirm_click2: 'Points are provided after confirmation of the transaction completion.',
    type: '%sType',
    no_room: 'No room'
  },
  site_detail: {
    my_field_memo: 'My Field Memo',
    my_memo_placeholder: 'Please write a site memo.',
    site_type: 'Site Type',
    building_info: 'Building Info',
    build_info: 'total %s building, %s households',
    parking_info: 'Parking Info',
    inlay_picture: 'Inlay picture',
    open_date_new: 'OPEN %s',
    open_date_general: 'OPEN %s',
    update_date: 'UPDATE %s',
    room_toilet_num: 'R%s/T%s',
    room_toilet_num_short: '%s/%s',
    r_single_hit: 'R %s',
    floor: 'Floor',
    ho: 'Ho',
    type: 'Type',
    area: 'Area (Py)',
    lease_price: 'Lease price(MYuan)',
    remark: 'Remark',
    about_area: 'About %sPy',
    teras: 'Teras',
    teras_short: '테',
    household_info: 'Household information',
    done: 'Done',
    meal: 'meal',
    room: 'Room',
    toilet: 'Toilet',
    toilet1: 'Toi',
    parcel_out: 'Parcel out',
    collateral_short: 'Collateral',
    collateral_short1: '담보',
    collateral: 'Collateral',
    private: '전용',
    private1: '전용면적',
    real_size: '실평',
    real_size1: '실제평수',
    dup_teras: '복/테',
    location_info: 'Location and surrounding facilities',
    here: 'Here',
    more_locations: 'More locations and nearby facilities',
    memo: 'Memo',
    group_site_set: '그룹매물 설정',
    group_share_space: '그룹 공유',
    person_manager: '1인 관리',
    call_phone: 'Call Phone',
    dup: '복',
    represent_photo: 'Represent Photo',
    no_recent_notification: 'No recent notification',
    recent_notification_days: 'Last notification %s days ago',
    site_inquire: 'Site Inquire',
    site_inquire_view: 'Site Inquire view',
    site_inquire_fee: '수수료 문의',
    site_inquire_short: '문의',
    desc_inquire_site: 'Please inquire on site.',
    view_notify: 'ViewNotification',
    already_reported_today: 'This is a site that has already been reported today.',
    already_reported_today_ho: '오늘 이미 제보된 세대입니다.',
    require_field_desc: '\'∙\' Mark is a required field',
    supply_meal_title: '오픈일자에 식대(현금) 지급을 하십니까?',
    supply_meal_content: '사은품(ex 수건, 다과, 텀블러 등)이 아닌\n‘식대(현금)’일 경우에만 체크해주세요.',
    residence_type: 'Residence',
    residence: '거주',
    vacancy: '공실',
    open_date: 'Open Year',
    dup_teras1: 'Dup/Teras',
    new_site_short: '[신축]',
    general_site_short: '[구옥]',
  },
  group: {
    view: 'View',
    transfer_warning_desc: 'Once transferred, can no longer manage the maemul.',
    transferred_to_sb: 'The maemul is transferred to %s',
    transfer_phone_placeholder: 'Enter member number to transfer maemul.',
    enter_phone_number: 'Please enter phone number.',
    enter_group_name: 'Please enter group name.',
    confirm_destination: 'Please enter phone number and click [View] button.',
    group_share: 'Group share',
    share_release: 'Share release',
    no_group: 'No Group',
    no_group_msg: 'No Group Member',
    group_member_mng: 'Group Member Mng',
    create_group: 'Create Group',
    add_group: 'Add Group',
    change_group_name: 'Change Group Name',
    delete_group_member: 'Delete Member',
    leave_group: 'Leave Group',
    add_group_member: 'Add Member',
    name: 'Name',
    member_number: 'Member Number',
    add_group_member_placeholder: 'Enter membership number to be added.',
    release_site_group_question: 'Are you want to unshare maemul?',
    no_sites_in_group: 'No maemuls in that group.',
    change_group_name_desc: 'Change to a new group name.',
    change_group_name_placeholder: 'Please enter a new group name.',
    create_group_title: 'Create a group',
    create_group_placeholder: 'Please enter a group name.',
    create_group_desc: 'Create a new group.',
    leave_group_question: 'Are you want to leave the group?',
    delete_group_member_placeholder: 'Enter membership number to be deleted.',
    select_group_title: 'Please select group to share site.',
    no_group_involved: 'There is no group affiliated with.',
    select_group: 'Please select group firstly.',
    share_success:'Shared successfully.',
    release_success:'Released successfully.',
    group_member_can: 'Group members can edit/delete maemul.',
    share_maemul_to_group: 'Share maemul to group.',
    create_or_invited_group: 'You must create a group or be invited to a group.',
    available_notify: 'AvailableN %s Gae',
    not_group_member: '그룹에 속한 회원이 아닙니다.',
  },
  room_info_popup: {
    gae: 'Gae',
    veranda: 'Veranda',
    utility_room: 'Utility room',
    duplex: 'Duplex',
    duplex_short: '복',
    private_size: 'PrivateSize',
    pyong: 'Pyong',
    sale_price: 'Sale price',
    parcel_price: 'Parcel price',
    man_won: 'ManYuan',
    invest: 'Investm',
    individual_photos: 'Individual site photos',
    memo: '세대 메모'
  },
  map: {
    my_site: 'My Maemul',
    group_site: 'Group Maemul',
    transfer_site: 'Transfer Maemul',
    all: 'All',
    shape: 'Shape',
    area: 'Area',
    r: 'R',
    period: 'Period',
    filter_all: '전체 필터',
    convenience_facility: 'Convenience Facility',
    safety_facility: 'Safety facility',
    district_info: 'District info',
    bus_sta: 'Bus Sta',
    subway_sta: 'Subway Sta',
    mart: 'Mart',
    convenience: 'Convenience',
    bank: 'Bank',
    drug_store: 'Drug Store',
    safety: 'Safety',
    cctv: 'CCTV',
    child_center: 'Child Center',
    kindergarden: 'Kindergarden',
    elementary_sc: 'Elementary Sc',
    middle_sc: 'Middle Sc',
    high_sc: 'High Sc',
    classification: 'Classification Sale',
    new_open_site: 'New open site',
    new_open_site_short: 'New',
    general_site: 'General Sale',
    general_site_short: 'General',
    room_nums: 'Room Nums',
    room_structure: 'Room Structure',
    price: 'Price',
    multi_selection: 'Multi selection is available',
    one_room: 'One Room',
    one_half_room: '1.5Room',
    two_room: 'Two Room',
    three_room: 'Three Room',
    four_room_more: 'Four room more',
    four_room: 'Four room',
    more: 'More',
    toilet_nums: 'Toilet Nums',
    one_toilet: '1Gae',
    two_toilet: '2Gae',
    three_toilet: '3Gae More',
    three_toilet1: '3Gae',
    elevator: 'Elevator',
    exist: 'Exist',
    none: 'None',
    trans_type: 'Trans Type',
    trans_type1: 'TransType',
    trans_type_desc: '새 오픈현장은 표시된 가격범위를 벗어난 경우 조회되지 않습니다.',
    charter_price: 'Charter Price',
    safe_charter: 'Safe Charter',
    small_business: 'Small Business',
    man: 'Man',
    investment: 'Investment',
    monthly_rent_deposit: 'Monthly rent deposit',
    deposit: 'Deposit',
    monthly_rent_price: 'Monthly rent price',
    monthly_rent: 'Monthly rent',
    exclusive_area: 'Exclusive Area',
    real_area: 'Real Area',
    unlimited: 'Unlimited',
    py_more: 'Py More',
    fee: 'Fee',
    fee1: 'Fee(백만원 단위)',
    court: 'Court',
    site_check: 'Site Check',
    regist_date: 'Regist Date',
    open_date: 'Open Date',
    registration_date: 'Registration date',
    opening_date: 'Opening date (Completion date)',
    select_period: 'Select Period',
    month: '%sMonth',
    year: '%sYear',
    year1: ' Year',
    year_month: '%sYear %sMonth',
    within: ' Within',
    before: ' before',
    today: 'Today',
    year_before: 'Year Before',
    current_show_sale: 'Currently show sale %sGae',
    no_search_result: 'No search result',
    no_search_keyword: 'Please enter a search keyword.',
    no_gps_permission: '현재 위치정보를 얻을 수 없습니다.',
    reset_filter: 'Reset the set filter.',
    m: '%sM',
    m1: '%sM',
    y: '%sY',
    site_report: 'Site report',
    site_report2: 'Site report',
    road_view: '로드뷰',
    favorite_sale: '관심매물',
    filter_set: '조건 설정',
    filter_been_set: '조건 설정됨',
    unfold_list: '목록 열기',
    fold_list: '목록 닫기',
    sort_site: '현장 단위',
    sort_ho: '세대 단위',
    sort_price_high: '가격 높은 순',
    sort_price_low: '가격 낮은 순',
    sort_collateral_high: '담보 높은 순',
    sort_collateral_low: '담보 낮은 순',
    site_inquire_display_none: '금액 현장문의 미표시',
    search_placeholer: '검색: 지역명 현장명 또는 현장 주소',
    road_view_guide: 'Click on the location or move the pin directly.',
    sort_collateral_price_desc: '실입(담보) 입력된 매물만 표시됩니다.',
    show_price_input_site_only_desc: '가격 입력된 매물만 표시됩니다.',
    show_site_inquire_only_desc: '가격 미입력된 매물이 표시됩니다.\n' + '(업데이트 빠른 순 기준)',
    no_matched_site: 'No matched site',
  },
  site_report: {
    search_site_name_placeholder: 'Search by site name',
    site_report: 'Site Report',
    unregistered_site: 'Unregistered site',
    report_result: 'Report Result',
    report_award: 'For accurate reporting, %s points will be awarded.',
    report_award_bound: '(Points are only available for newly opened sites.)',
    report_award_exception: 'Your site is excluded form providing points.',
    report_inaccurate_disadvantage: 'There may be disadvantages when inappropriate reports accumulate.',
    report_inaccurate_disadvantage1: 'There may be disadvantages when inappropriate reports accumulate.',
    report_exception: '(Your site is excluded, and points are provided only for newly opened sites.)',
    site_completion: 'Site completion',
    ho_completion: '세대완료',
    site_completion1: 'Site completion',
    site_shutdown: 'Site shutdown',
    site_resumption: 'Site resumption',
    sales_team_change: 'Sales team change',
    price_change: 'Price change',
    reject: 'Reject',
    payment: 'Payment',
    site_transfer: 'Site Transfer',
    process_success: 'Successfully processed.',
    transfer_site_done: 'Transfer site successfully done.',
    accept_report: 'had confirmed. %s points were awarded.',
    reject_report: 'Points were not awarded because it was different from what you are reported.',
    report_btn: 'Report',
    want_say_manager: 'What to say about reporting',
    want_say_manager2: 'What to say about reporting',
    want_say_manager_placeholder: 'If you have something to say to the maid manager, please enter it.',
    report_house_desc: '[세대완료], [해약세대] 제보 시 100P 지급'
  },
  community: {
    all: 'All',
    notice: 'Notice',
    find_site: 'Find site',
    worker_job: 'Worker/Job',
    report: 'Report',
    report1: 'Report1',
    title: 'Title',
    content: 'Content',
    title_content: 'Title + Content',
    phone: 'Phone',
    site: 'Site',
    writing: 'Writing',
    post_edit: 'Post edit',
    phone_placeholder: 'Please enter a phone number.',
    title_placeholder: 'Please enter a title.',
    content_placeholder: 'Please enter the content.',
    agree_honest_content_only_placeholder: 'Please agree honest contents only.',
    contacts_input: 'Please input contact No1',
    attachments: 'Attachments',
    made_guide: 'When using made, Fixed for 24 hours at top of main notification.',
    push: 'PUSH',
    made_plus: 'Made+',
    writing_possible: 'Writing possible %sGon',
    anony: 'anony',
    agree_honest_content_only_desc: 'If you register images or entries that contains not suitable contents, if may be removed without notice.',
    anony_writer: 'anony writer',
    writing_limit_desc: 'At the day sign\n %s cases will be generated\n',
    push_title: 'Use PUSH notifications.',
    push_content: 'Notifications are sent to Made users.\n%s points are consumed when used.',
    push_content1: 'Push left: %s',
    made_title: 'Use Made+.',
    made_content: 'It is fixed at the top of the entire board for 24 hours.\n' +
      '%s points are consumed when used.\n(It is irrelevant to the number of writing possible.)\n',
    made_content1: 'Made+ left: %s',
    made_content2: 'It is fixed at the top of the entire board for 24 hours.\n' +
      '%s points are consumed when used.\n(It is irrelevant to the number of writing possible.)\n',
    call: 'Call',
    send_msg: 'Send Msg',
    delete_confirm_title: 'Are you sure you want to delete the selected community post?\n',
    delete_confirm: 'When deleted, recovery is not possible.',
    delete_comment_confirm: 'Delete comment.',
    mine: 'Mine',
    comment: 'Comment',
    comment_guide: 'when registering a comment, a silent notification is sent to the author.',
    regist: 'Regist',
    prevent_btn: 'Prevent',
    report_btn: 'Report',
    prevent_comment_btn: 'Prevent',
    report_comment_btn: 'Report',
    ask_prevent: 'Are you sure to prevent this writing?',
    ask_cmment_prevent: 'Are you sure to prevent this writing?',
    report_success: 'Report success!!.',
    report_success1: 'Report success!!.',
    comment_placeholder: 'Please enter your comments'
  },
  more: {
    show: 'Show',
    hide: 'Hide',
    days_left: '%s days left',
    extends: 'extends',
    points_remain: 'Points remaining %s P',
    auto_hide_waring: 'There are %s days left until the \'auto-hide\' of the sale.',
    auto_hidden_maemul: "This is 'Auto-hide' sale.",
    send_noti: 'Send notification',
    noti_modify: 'Noti Modify',
    noti_receive: 'Noti received today',
    auto_noti: 'Auto Noti',
    sale_regist: 'Sale Regist',
    sale_list: 'Sale List',
    sale_complete: 'Sales completed',
    sale_complete1: 'Sales completed',
    area_calc: 'Area calculation',
    loan_calc: 'Loan calculation',
    nearby_transport: 'Nearby transport',
    inquire: 'Inquire',
    point_charging: 'Point charging',
    setting: 'Setting',
    terms_of_use: 'Terms of use',
    privacy_policy: 'Privacy Policy',
    about_us: 'About Us',
    customer_center: 'Customer Center %s',
    site_name_placeholder: 'Please enter the site name.',
    site_name_placeholder1: 'Please enter the site name.',
    address_placeholder: 'Please enter the address.',
    link_my_site: 'Link my site info',
    copy_previous_notifications: 'Copy previous notifications',
    auto_noti_setting: 'Auto Noti Setting',
    search_address: 'Search for an address',
    address_search: 'Address search',
    noti_made_content: 'It is fixed for 24 hours at the top of the main screen notification.\n' +
      '%s points are consumed when using it.\n(It is irrelevant to the number of possible notifications.)',
    noti_guide: 'When using Made+, fixed for 24 hours at top of main notification.',
    noti_tooltip: 'notifications available %s gon',
    select_site: 'Select Site',
    no_site: 'No registered site',
    no_notify: 'No registered notify',
    address_popup_placeholder: 'Enter the jibun, road name.',
    road_name: 'RoadName',
    set_cur_location: 'Set current location',
    detail_address_placeholder: 'Please enter a detailed address.',
    view_by: 'View by road name address',
    set_address: 'Set address to this location',
    sale_registration: 'Regist',
    reg_regist: 'Reg Request',
    loan_method: 'Loan method',
    loan_principal: 'Loan principal',
    loan_period: 'Load period',
    loan_interest_rate: 'Loan interest rate',
    input_all: 'Please input all information',
    division: 'Division',
    cal_result: 'Calculation result',
    avg_monthly_pay: 'Average monthly payment',
    total_interest_paid: 'Total interest paid',
    avg_monthly_interest_amt: 'Average monthly interest amount',
    view_monthly_payment: 'View monthly payment',
    calculate: 'Calculate',
    round: 'Round',
    repay_principal_rate: 'Repayment principal rate',
    repay_principal: 'Repayment principal',
    monthly_loan_interest: 'Monthly loan interest',
    loan_balance: 'Loan balance',
    push_vibration: 'Push vibration on and off',
    push_noti: 'Push notification on and off',
    set_noti_disturb: 'Set notification do not disturb time',
    start_time: 'Start time',
    end_time: 'End time',
    set_my_info: 'Set my info',
    point_history: 'Point history',
    logout: 'Logout',
    logout_confirm: 'Are you sure you want to logout?',
    withdrawal: 'Withdrawal',
    withdraw_title: 'Are you sure you want to withdraw?',
    withdraw_confirm: 'Are you sure you want to withdraw?',
    on_withdrawed: 'You have been withdrawn normally.',
    withdraw_phone: 'Enter phone number.',
    date: 'Date',
    history: 'History',
    inc_or_dec: 'Increase or decrease',
    remain_point: 'Remaining points',
    charge_point: 'Charging points',
    charge_point1: 'Charging points',
    bonus: '+%s% bonus',
    payment_method: 'Payment Method',
    credit_card: 'Credit card',
    kt_pay: 'KTPay',
    point_remain: 'Points remaining %sP',
    go_transfer_account: '충전 방식이 어렵다면 계좌이체 하러 가기',
    total_pay_amount: 'Total payment amount',
    charging: 'Charging',
    vat: '(VAT포함)',
    load_temporary_save: 'Do you want to load temporary save info?',
    usage_extension: 'Usage Extension',
    d_usage: '%sD Usage',
    point: '%s P',
    gae: '%sGae',
    made_remain_gae: 'Made+ Remaining %sGae',
    push_remain_gae: 'PUSH Noti Remaining %sGae',
    payment_point: 'Payment Point',
    purchase: 'Purchase',
    point_not_enough: 'Point is not enough',
    point_purchase: 'Are you charge?',
    usage_expired_title: 'Sorry, you need to purchase usage first.',
    usage_expired: 'Are you purchase?',
    usage_success: 'Successfully purchase usage.'
  },
  notify: {
    today_list: 'Today notify list',
    site_name: 'SiteName',
    location: 'Location',
    contact: 'Contact',
    contact1: 'Site Contact',
    site_info: 'Site info',
    noti_content: 'Notification contents',
    read_all: 'Read All',
    delete_title: 'Are you sure you want to delete the selected notification?',
    delete_confirm: 'When deleted, recovery is not possible.',
    auto_noti_title: 'Auto Noti Set%s',
    auto_noti_interval: 'Notification sending interval',
    auto_noti_time: 'Notification sending time',
    auto_noti_every_day: 'Every\nDay',
    auto_noti_3_day: '3Day',
    auto_noti_5_day: '5Day',
    create_auto_notify: 'Automatic notification creation',
    ask_delete_auto_notify: 'Are you sure to delete this auto notification?',
  },
  inquire: {
    sale_register: 'RegistSale',
    usage: 'How to use',
    ads: 'Ads',
    community: 'Community',
    point: 'Point',
    point1: 'Point1',
    other: 'Other',
    save: 'Save',
    secret: 'Secret',
    news: 'News',
    answer: 'Answer',
    answer_placeholder: 'Please enter the answer.',
    answer_success: 'Inquire answered successfully.',
    delete_confirm: 'Are you sure you want to delete this inquire?',
    mine: 'My Quiz',
    secret_inquire: 'You are not allowed to view this inquire.',
    answer_complete: '[Answer Complete]'
  },
  complete: {
    toggle_site_complete : 'Set/Cancel Sales Completion',
    sold_out_hint: 'Made always wishes the site to be sold out',
    sold_out_hint_desc: 'Can designate sale completion/cancellation by click.\nInformation is updated in the registered property info.'
  },
  register: {
    reg_new_open_site: 'Registration new open site',
    site_name: 'Site Name',
    address: 'Address',
    search_address: 'Search Address',
    add: 'Add',
    complex_info: 'Complex information',
    total: 'Total',
    gae_dong: 'Gae Dong',
    household: 'Household',
    million_man_won: 'MillionManYuan',
    single_hit: 'Single hit',
    double_hit: 'Double hit',
    none_hit: 'None',
    inlay_reg: 'Inlay registration',
    private: 'Private',
    memo_guide: 'The first line is the main introduction to the listing',
    memo_guide1: 'The first line is the main introduction to the listing',
    memo_guide2: 'The first line is the main introduction to the listing',
    temporary_save: 'Temporary save',
    east_floor: 'East/Line/Household information',
    east_floor2: '(단일 동일 경우 동에 ‘1’ 기재)',
    reg_represent_photo: 'Register representative site photos',
    reg_photo_guide: 'The first picture is displayed as a represent.',
    memo_placeholder: 'Please write a site memo.',
    on_site_photo_reg: 'On-site photo registration',
    on_site_photo_reg1: '매물사진 등록',
    modify_new_open_site: 'New open site modification',
    modify_general_sale: 'General sale modification',
    register_general_sale: 'Registration for general sales',
    modify_unregistered_site: 'Unregistered site modification',
    contact_placeholder: 'Please enter the contact information.',
    complex_info_placeholder: 'Please enter the complex information.',
    maemul_type_placeholder: 'Please select the maemul type.',
    trans_type_placeholder: 'Please select the transaction type.',
    trans_cost_placeholder: 'Please input transaction price',
    trans_cost_placeholder1: '금액정보가 입력되지 않았습니다.',
    room_num_placeholder: 'Please select the room number.',
    toilet_num_placeholder: 'Please select the toilet number.',
    veranda_num_placeholder: '베란다 개수를 설정하세요.',
    utility_room_num_placeholder: '다용도실 개수를 설정하세요.',
    elevator_placeholder: 'Please select the elevator exist status.',
    area_placeholder: 'Please select the area type.',
    area_info_placeholder: 'Please input area info.',
    fee_type_placeholder: 'Please select the fee type.',
    fee_info_placeholder: 'Please input fee info.',
    dong_name_placeholder: 'Please input the dong name.',
    limited_ho_count: 'You can not add household in this site anymore.',
    dong_limited_ho_count: 'You can not add household in this dong anymore.',
    copy_floor_ho_count_not_match: 'The household count that you want to copy dose not match.',
    copy_floor_ho_count_not_match1: '먼저 복사 받을 세대 수를 동일하게 설정해주십시오.',
    copy_src_empty: 'src floor don\'t have ho.',
    save: 'Save',
    dong: 'Dong',
    floor: 'Floor',
    line: '라인',
    input: 'Input%s',
    ho: 'Ho',
    ho_input: 'household input',
    ho_input_desc: 'Please enter the follower structure from the 2nd floor.',
    copy_info: 'Copy info',
    to_this_floor: 'to this floor',
    to_this_floor1: 'to this floor',
    all_info: 'All info',
    only_photo: 'Only photos',
    apply : 'Apply',
    room: 'Room',
    toilet: 'Toilet',
    parcel_out: 'Parcel Out',
    exclusive_size: 'Exclusive Size',
    exclusive: 'Exclusive',
    real_size: 'Real Size',
    real_size1: 'Real Size1',
    ho_name: 'Household Name',
    ho_name_hint: 'Name can modified',
    million_man_won2: 'MiMYuan',
    ho_memo_hint: 'Please write a site memo.',
    multi_select: 'Multi Select',
    unit_money: '(단위1 = 백만원)',
    unit_money2: ' (단위1 = 100만원, 중복 선택 가능)',
    r_residence: '실거주',
    structure: '구조',
    unspecified: '미기재',
    trading_price: '매매 금액',
    charter_price: '전세 금액',
    invest_price: '투자 금액',
    trading_fee: '매매 수수료',
    charter_fee: '전세 수수료',
    monthly_fee: '월세 수수료',
    invest_fee: '투자 수수료',
  },

};



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js